import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';
import { MbbProduct } from '../modules/mbb/models/mbb-product.model';
import { CustomerProductMbbSelectors } from '../modules/mbb/states/customer-product-mbb.selectors';

export function RepeatedMbbIccValidator(productId: string, store): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const newMbbProducts = store.selectSnapshot(CustomerProductMbbSelectors.getNewMbbProducts);
    const isProductsComparable = newMbbProducts && newMbbProducts.length > 1;

    if (isProductsComparable) {
      const mbbProductsWithIcc = newMbbProducts.filter(
        (newMbbProduct: MbbProduct) => newMbbProduct.id !== productId && newMbbProduct?.icc
      );
      const isRepeatedIcc = mbbProductsWithIcc.some(
        (mbbProductWithIcc: MbbProduct) => mbbProductWithIcc.icc === control.value
      );

      return isRepeatedIcc ? { simCardRepeated: true } : null;
    }

    return null;
  };
}
